import { Component, input } from '@angular/core';

import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';

@Component({
  selector: 'app-hamburger-menu-atom',
  templateUrl: './hamburger-menu-atom.component.html',
  styleUrls: ['./hamburger-menu-atom.component.scss'],
  imports: [ContentBuilderColorPipe],
})
export class HamburgerMenuAtomComponent {
  light = input(false);
  size = input<'S' | 'M'>('M');
  color = input<IContentBuilderFieldColor | undefined>(undefined);
}
